import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { HeaderSkeleton } from './HeaderSkeleton';

export const Header = () => {
  const ReduxHeader = useLazyComponent(() =>
    import(/* webpackChunkName: "header" */ 'app/gamma/src/components/header'),
  );
  return (
    <Suspense fallback={<HeaderSkeleton />}>
      <ReduxHeader />
    </Suspense>
  );
};
